import "../scss/styles.scss";

import onChange from 'on-change';

import calc from './calc';
import {render} from './render';
import {tabsModalStart} from "./function";
import {webflowRestart} from "./utils";
import htmlTemplateForm from "./htmlTemplateForm";

// controller
// watch switcher changes
const updateExclude = (form, watchedState) => {
    const excludesElements = form.querySelectorAll('.switcher');
    const {exclude} = watchedState.form;

    for (let i = 0; i < excludesElements.length; i++) {
        excludesElements[i].addEventListener('change', function() {
            let siblingInput = excludesElements[i].parentNode.parentNode.parentNode.querySelector('.input');
            siblingInput.value = '';

            if (excludesElements[i].value === '$') {
                if(siblingInput.name === 'rental-insurance'){
                    siblingInput.step = '1';
                    siblingInput.placeholder = '100';
                }
                if(siblingInput.name === 'annual-tax'){
                    siblingInput.step = '1000';
                    siblingInput.placeholder = '1000';
                }
                if(siblingInput.name === 'annual-insurance'){
                    siblingInput.step = '100';
                    siblingInput.placeholder = '100';
                }
                if(siblingInput.name === 'annual-pmi'){
                    siblingInput.step = '100';
                    siblingInput.placeholder = '100';
                }
                if(siblingInput.name === 'points'){
                    siblingInput.step = '100';
                    siblingInput.placeholder = '100';
                }
            } else {
                if(siblingInput.name === 'rental-insurance'){
                    siblingInput.step = '0.1';
                    siblingInput.placeholder = '0.1';
                }
                if(siblingInput.name === 'annual-tax'){
                    siblingInput.step = '0.1';
                    siblingInput.placeholder = '0.1';
                }
                if(siblingInput.name === 'annual-insurance'){
                    siblingInput.step = '0.1';
                    siblingInput.placeholder = '0.1';
                }
                if(siblingInput.name === 'annual-pmi'){
                    siblingInput.step = '0.1';
                    siblingInput.placeholder = '0.1';
                }
                if(siblingInput.name === 'points'){
                    siblingInput.step = '0.125';
                    siblingInput.placeholder = '0.125';
                }
            }
        });
    }

    [...excludesElements].forEach((excludeItem) => {
        if (excludeItem.checked) {
            exclude[excludeItem.name] = excludeItem.value;
        }
    });
};

const updateValues = (elements, watchedState) => {
    const {values} = watchedState.form;
    const {form} = elements;
    const formData = new FormData(form);
    // update values
    [...formData.entries()].forEach(([key, value]) => {
        if (key in values) {
            values[key] = value === '' ? 0 : +value;
        }
    });

    // update exclude list
    updateExclude(form, watchedState);
};

const updateUserValues = (elements, watchedState) => {
    const {user} = watchedState.form;
    const {form} = elements;
    const formData = new FormData(form);

    // update values
    [...formData.entries()].forEach(([key, value]) => {
        if (key in user) {
            user[key] = value;
            // console.log(values[key])
        }
    });

    // update exclude list
    updateExclude(form, watchedState);
};

const init = () => {

    const isTemplate = htmlTemplateForm();
    tabsModalStart();

    if (!isTemplate) {
        return false;
    }

    // MODEL
    const elements = {
        form: document.forms.calculatorRentBuy,
        formRerender: document.getElementById('rerender'),
        modalSending: document.getElementById('modalSendResult'),
        // values
        resultMonthlyRent: document.querySelectorAll('[data-calc-result="monthly-rent"]'),
        resultAnnualRentIncrease: document.querySelectorAll('[data-calc-result="annual-rent-increase"]'),
        resultRentalInsurance: document.querySelectorAll('[data-calc-result="rental-insurance"]'),
        resultAnnualMaintenance: document.querySelectorAll('[data-calc-result="annual-maintenance"]'),
        resultAnnualAppreciation: document.querySelectorAll('[data-calc-result="annual-appreciation"]'),
        resultHomeValue: document.querySelector('[data-calc-result="home-value"]'),
        resultHomeValueNoPennies: document.querySelector('[data-calc-result="home-value-no-pennies"]'),
        resultYearsBefore: document.querySelectorAll('[data-calc-result="years-before"]'),
        resultSellingCost: document.querySelectorAll('[data-calc-result="selling-cost"]'),
        resultAmount: document.querySelectorAll('[data-calc-result="amount"]'),
        resultAmountNoPennies: document.querySelectorAll('[data-calc-result="amount-no-pennies"]'),
        resultInterestRate: document.querySelectorAll('[data-calc-result="interest-rate"]'),
        resultTerm: document.querySelectorAll('[data-calc-result="term"]'),
        resultPoints: document.querySelectorAll('[data-calc-result="points"]'),
        resultYourTaxRate: document.querySelectorAll('[data-calc-result="your-tax-rate"]'),
        resultAnnualTax: document.querySelectorAll('[data-calc-result="annual-tax"]'),
        resultAnnualInsurance: document.querySelectorAll('[data-calc-result="annual-insurance"]'),
        resultAnnualPmi: document.querySelectorAll('[data-calc-result="annual-pmi"]'),

        // part 1
        resultTotalPrincipalRent: document.querySelectorAll('[data-calc-result="total-principal-rent"]'),
        resultTotalPrincipalBuy: document.querySelectorAll('[data-calc-result="total-principal-buy"]'),
        resultTaxesInsuranceRent: document.querySelectorAll('[data-calc-result="taxes-insurance-rent"]'),
        resultTaxesInsuranceBuy: document.querySelectorAll('[data-calc-result="taxes-insurance-buy"]'),
        resultPmiRent: document.querySelectorAll('[data-calc-result="pmi-rent"]'),
        resultPmiBuy: document.querySelectorAll('[data-calc-result="pmi-buy"]'),
        resultMaintenanceRent: document.querySelectorAll('[data-calc-result="maintenance-rent"]'),
        resultMaintenanceBuy: document.querySelectorAll('[data-calc-result="maintenance-buy"]'),
        resultTotalPaymentsRent: document.querySelectorAll('[data-calc-result="total-payments-rent"]'),
        resultTotalPaymentsBuy: document.querySelectorAll('[data-calc-result="total-payments-buy"]'),

        // part 2
        resultAverageMonthlyRent: document.querySelectorAll('[data-calc-result="average-monthly-rent"]'),
        resultAverageMonthlyBuy: document.querySelectorAll('[data-calc-result="average-monthly-buy"]'),
        resultMonthlyRentSavings: document.querySelectorAll('[data-calc-result="monthly-rent-savings"]'),
        resultTaxSavingsRent: document.querySelectorAll('[data-calc-result="tax-savings-rent"]'),
        resultTaxSavingsBuy: document.querySelectorAll('[data-calc-result="tax-savings-buy"]'),
        resultTotalRentSavings: document.querySelectorAll('[data-calc-result="total-rent-savings"]'),

        // part 3
        resultHouseAppreciationValue: document.querySelectorAll('[data-calc-result="house-appreciation-value"]'),
        resultProceedsMinusCosts: document.querySelectorAll('[data-calc-result="proceeds-minus-costs"]'),
        resultLoanBalance: document.querySelectorAll('[data-calc-result="loan-balance"]'),
        resultEquityAppreciation: document.querySelectorAll('[data-calc-result="equity-appreciation"]'),
        resultClosingCost: document.querySelectorAll('[data-calc-result="closing-cost"]'),
        resultHomePurchaseBenefits: document.querySelectorAll('[data-calc-result="home-purchase-benefits"]'),

        // sending status
        success: document.querySelector('.form-send__status-ok'),
        error: document.querySelector('.form-send__status-fail'),
    };

    // MODEL
    const state = {
        form: {
            user: {
                'name': '',
                'email': '',
                'phone': '',
            },
            values: {
                // input values
                'monthly-rent': 0,
                'rental-insurance': 0,
                'annual-rent-increase': 0,
                'annual-maintenance': 0,
                'annual-appreciation': 0,
                'home-value': 0,
                'years-before': 0,
                'selling-cost': 0,
                'hoa-dues': 0,
                'amount': 0,
                'interest-rate': 0,
                'term': 0,
                'points': 0,
                'your-tax-rate': 0,
                'annual-tax': 0,
                'annual-insurance': 0,
                'annual-pmi': 0,
            },
            exclude: {
                'switch-rental-insurance': '$',
                'switch-tax-rate': '%',
                'switch-taxes': '$',
                'switch-insurance': '$',
                'switch-pmi': '%',
                'switch-points': '%',
            },
        },
        result: {
            // first
            'total-monthly-rent': 0,
            'total-monthly-buy': 0,

            'taxes-insurance-rent': 0,
            'taxes-insurance-buy': 0,
            'pmi-rent': 0,
            'pmi-buy': 0,
            'maintenance-rent': 0,
            'maintenance-buy': 0,
            'total-payments-rent': 0,
            'total-payments-buy': 0,

            'average-monthly-rent': 0,
            'average-monthly-buy': 0,
            'monthly-rent-savings': 0,
            'tax-savings-rent': 0,
            'tax-savings-buy': 0,
            'total-rent-savings': 0,

            'house-appreciation-value': 0,
            'proceeds-minus-costs': 0,
            'loan-balance': 0,
            'equity-appreciation': 0,
            'closing-cost': 0,
            'home-purchase-benefits': 0,
        },
    };

    // MODEL
    const watchedState = onChange(state, () => {
        calc(elements, watchedState);
    });

    // CONTROLLER
    const {form, formRerender, modalSending} = elements;
    const {result} = watchedState;
    const {values, exclude, user} = watchedState.form;

    formRerender.addEventListener('click', (e) => {
        e.preventDefault();
        render(elements, watchedState);
    });

    form.addEventListener('submit', (e) => {
        e.preventDefault();
        updateValues(elements, watchedState);
        updateUserValues(elements, watchedState);

        let submitter = e.submitter,
            submitCurrentText = submitter.innerHTML,
            submitWaitText = submitter.dataset.wait,
            submitErrorText = submitter.dataset.error,
            submitSuccessText = submitter.dataset.success;

        let formData = {
            // form id
            "form_id": elements.form.id,
            // user data
            "name": user["name"],
            "email": user["email"],
            "phone": user["phone"],
            // input data
            "monthly_rent": values["monthly-rent"],
            "annual_rent_increase": values["annual-rent-increase"],
            "rental_insurance": values["rental-insurance"],
            "home_value": values["home-value"],
            "annual_maintenance": values["annual-maintenance"],
            "annual_appreciation": values["annual-appreciation"],
            "years_before": values["years-before"],
            "selling_cost": values["selling-cost"],
            "hoa_dues": values["hoa-dues"],

            "amount": values["amount"],
            "interest_rate": values["interest-rate"],
            "term": values["term"],
            "points": values["points"],

            "your_tax_rate": values["your-tax-rate"],
            "annual_tax": values["annual-tax"],
            "annual_insurance": values["annual-insurance"],
            "annual_pmi": values["annual-pmi"],

            // switches
            "switch_rental_insurance": exclude["switch-rental-insurance"],
            "switch_tax_rate": exclude["switch-tax-rate"],
            "switch_taxes": exclude["switch-taxes"],
            "switch_insurance": exclude["switch-insurance"],
            "switch_pmi": exclude["switch-pmi"],

            // results
            "taxes_insurance_rent": result["taxes-insurance-rent"],
            "taxes_insurance_buy": result["taxes-insurance-buy"],

            "pmi_rent": result["pmi-rent"],
            "pmi_buy": result["pmi-buy"],

            "maintenance_rent": result["maintenance-rent"],
            "maintenance_buy": result["maintenance-buy"],

            "total_payments_rent": result["total-payments-rent"],
            "total_payments_buy": result["total-payments-buy"],

            "average_monthly_rent": result["average-monthly-rent"],
            "average_monthly_buy": result["average-monthly-buy"],

            "monthly_rent_savings": result["monthly-rent-savings"],

            "tax_savings_rent": result["tax-savings-rent"],
            "tax_savings_buy": result["tax-savings-buy"],

            "total_rent_savings": result["total-rent-savings"],

            "house_appreciation_value": result["house-appreciation-value"],
            "proceeds_minus_costs": result["proceeds-minus-costs"],
            "loan_balance": result["loan-balance"],
            "equity_appreciation": result["equity-appreciation"],
            "closing_cost": result["closing-cost"],
            "home_purchase_benefits": result["home-purchase-benefits"],
        };

        // ***
        if (user["email"] !== '') {
            submitter.innerHTML = submitWaitText;
            fetch("https://digitalbutlers.me/any_scripts/ligolab/sheets/test/send_results.php", {
                method: "POST",
                body: JSON.stringify(formData),
                // body: formData,
            }).then(function (response) {
                if (response.status === 200) {
                    submitter.innerHTML = submitSuccessText;
                    setTimeout(function () {
                        modalSending.classList.remove('open');
                        document.body.classList.remove("no-scroll");
                        submitter.innerHTML = submitCurrentText;
                        form.reset();
                    }, 1000)
                } else {
                    submitter.innerHTML = submitErrorText;
                    setTimeout(function () {
                        modalSending.classList.remove('open');
                        document.body.classList.remove("no-scroll");
                        form.reset();
                        submitter.innerHTML = submitCurrentText;
                    }, 1000)
                }
            }).catch(function (error) {
                submitter.innerHTML = submitErrorText;
                console.log(error);
            });
        } else {
            submitter.innerHTML = submitErrorText;
            setTimeout(function () {
                modalSending.classList.remove('open');
                document.body.classList.remove("no-scroll");
                form.reset();
                submitter.innerHTML = submitCurrentText;
            }, 1000)
        }
    });

    form.addEventListener('change', () => {
        updateValues(elements, watchedState);
        render(elements, watchedState);
    });

    // FIRST START
    updateValues(elements, watchedState);
    render(elements, watchedState);

    // Restart webflow scripts
    webflowRestart();
};

init();